if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      if (window.location.href.includes("/search-results-page")) {
        updateProductAttributes();
        handleLazyLoad();
      }
    }, 2000);

    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        // console.log(MutationList);
        for (let item of MutationList) {
          if (item.target.classList.contains("snize-filters-sidebar")) {
            setTimeout(() => {
              updateProductAttributes();
              handleLazyLoad();
            }, 1500);
          }
          if (item.target.id === "snize-instant-search-results") {
            setTimeout(() => {
              updateProductAttributesSearchBar();
              handleLazyLoad();
            }, 1500);
          }
          if (item.target.classList.contains("side-panel-content")) {
            document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
          }
          if (item.target.classList.contains("form__label__value")) {
            setTimeout(() => {
              BSS_B2B.observer.productSubject.notifyObserver(
                "ProductMutate",
                "ProductPriceMutate"
              );
            }, 1000);
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }, 300);

    function updateProductAttributes() {
      document
        .querySelectorAll(".snize-search-results-main-content li.snize-product")
        .forEach((li) => {
          const productId = li.getAttribute("data-original-product-id");
          const priceElement = li.querySelector(".snize-price-list");
          if (productId && priceElement) {
            priceElement.setAttribute("bss-b2b-product-id", productId);
            priceElement.setAttribute("bss-b2b-product-price", "");
          }
        });
    }

    function updateProductAttributesSearchBar() {
      document
        .querySelectorAll(".snize-ac-results-multicolumn-list li.snize-product")
        .forEach((li) => {
          const productId = li.getAttribute("data-original-product-id");
          const priceElement = li.querySelector(".snize-price-list");
          if (productId && priceElement) {
            priceElement.setAttribute("bss-b2b-product-id", productId);
            priceElement.setAttribute("bss-b2b-product-price", "");
          }
        });
    }

    async function handleLazyLoad() {
      if (BSS_B2B) {
        const res = await BSS_B2B.storage.productStorage.load();
        if (res) {
          if (
            res.notExistProductIds?.length ||
            res.productIds?.length ||
            res.variantIds?.size
          ) {
            BSS_B2B.observer.productSubject.notifyObserver(
              "LazyProduct",
              "LoadedLazyProduct",
              {
                ...res,
              }
            );
          }
        }
      }
    }

    function updateCartPrices() {
      if (
        !BSS_B2B?.storage?.cartStorage?.store ||
        BSS_B2B.storage.cartStorage.store.size === 0
      ) {
        console.warn("Cart storage is empty or unavailable.");
        return;
      }
      const cartMap = new Map();
      BSS_B2B.storage.cartStorage.store.forEach((value) => {
        cartMap.set(value.variant_title, value.key);
      });
      BSS_B2B.observer.cartSubject.notifyObserver(
        "CartMutate",
        "CartPriceMutate"
      );
    }

    function shouldShowVATForm(settings, customer) {
      let isShowVATForm = false;
      const vatEnabled = [
        settings.vatSetting.enable_eu_vat,
        settings.vatSetting.enable_uk_vat,
        settings.vatSetting.enable_gst,
        settings.vatSetting.enable_us_ein,
        settings.vatSetting.enable_abn,
      ].includes(1);
      if (vatEnabled) {
        switch (settings.vatSetting.show_vat_apply_to) {
          case 0:
            isShowVATForm = true;
            break;
          case 1:
            if (customer) isShowVATForm = true;
            break;
          case 2:
            if (!customer) isShowVATForm = true;
            break;
          case 3:
            if (customer) {
              const customerTags = customer.tags.map((tag) =>
                tag.toLowerCase()
              );
              const teTags = [settings.vatSetting.show_vat_customer_tags].map(
                (tag) => tag.toLowerCase()
              );
              if (teTags.some((tag) => customerTags.includes(tag))) {
                isShowVATForm = true;
              }
            }
            break;
          case 4:
            if (customer) {
              const customerIdString = String(customer.id);
              const rawIds = settings.vatSetting.show_vat_customer_ids;
              const customerIdsString =
                typeof rawIds === "string"
                  ? rawIds.split(",").map((id) => id.trim())
                  : Array.isArray(rawIds)
                  ? rawIds.map(String)
                  : [];
              if (customerIdsString.includes(customerIdString)) {
                isShowVATForm = true;
              }
            }

            break;
        }
      }
      return isShowVATForm;
    }

    function renderVATFormIfNeeded(settings, customer) {
      if (!shouldShowVATForm(settings, customer)) return;
      const vatExemptSelected = settings.vatExemptSelected;
      const translations = settings.teTranslations;
      const formHeaders = [
        translations.form_header_text,
        translations.form_header_text_uk,
        translations.form_header_text_abn,
        translations.form_header_text_gst,
        translations.form_header_text_us_ein,
      ];
      const formSubtitles = [
        translations.form_subtitle_text,
        translations.form_subtitle_text_uk,
        translations.form_subtitle_text_abn,
        translations.form_subtitle_text_gst,
        translations.form_subtitle_text_us_ein,
      ];
      const errorMessages = [
        translations.form_error_message,
        translations.form_error_message_uk,
        translations.form_error_message_abn,
        translations.form_error_message_gst,
        translations.form_error_message_us_ein,
      ];
      const successMessages = [
        translations.form_success_message,
        translations.form_success_message_uk,
        translations.form_success_message_abn,
        translations.form_success_message_gst,
        translations.form_success_message_us_ein,
      ];

      const tax_extempt_ele = `
  <div class="bss-b2b-tax-ex-wrapper bss-config-header">
    <h3 class="bss-vat-exempt-form-header-text">
      <span class="bss-b2b-translation-vat-form_header_text">
        ${formHeaders[vatExemptSelected] || ""}
      </span>
    </h3>
    <p class="bss-vat-exempt-form-subtitle-text">
      <span class="bss-b2b-translation-vat-form_subtitle_text">
        ${formSubtitles[vatExemptSelected] || ""}
      </span>
    </p>
    <div class="bss-b2b-vat-input-wrapper">
      <select name="bss-b2b-vat-selected" class="bss-b2b-vat-selected">
        ${
          settings.vatSetting.enable_eu_vat == "1"
            ? `<option value="0">EU</option>`
            : ""
        }
        ${
          settings.vatSetting.enable_uk_vat == "1"
            ? `<option value="1">UK</option>`
            : ""
        }
        ${
          settings.vatSetting.enable_abn == "1"
            ? `<option value="2">ABN</option>`
            : ""
        }
        ${
          settings.vatSetting.enable_gst == "1"
            ? `<option value="3">India GST</option>`
            : ""
        }
        ${
          settings.vatSetting.enable_us_ein == "1"
            ? `<option value="4">US EIN</option>`
            : ""
        }
      </select>
      <input type="text" name="bss-b2b-eu-tax" class="bss-b2b-vat-input" />
    </div>
    <div class="bss-b2b-tax-ex-message">
      <p class='bss-b2b-tax-invalid'>
        <span class="tax-icon-error">&#10005;</span>
        <span class="tax-message tax-error-message">
          <span class="bss-b2b-translation-vat-form_error_message">${
            errorMessages[0]
          }</span>
          <span class="bss-b2b-translation-vat-form_error_message_uk">${
            errorMessages[1]
          }</span>
          <span class="bss-b2b-translation-vat-form_error_message_abn">${
            errorMessages[2]
          }</span>
          <span class="bss-b2b-translation-vat-form_error_message_gst">${
            errorMessages[3]
          }</span>
          <span class="bss-b2b-translation-vat-form_error_message_us_ein">${
            errorMessages[4]
          }</span>
          <span class="bss-b2b-translation-vat-form_validate_country_code_message">
            ${translations.form_validate_country_code_message}
          </span>
        </span>
      </p>
      <p class='bss-b2b-tax-valid'>
        <span class="tax-icon-success">&#10003;</span>
        <span class="tax-message tax-success-message">
          <span class="bss-b2b-translation-vat-form_success_message">${
            successMessages[0]
          }</span>
          <span class="bss-b2b-translation-vat-form_success_message_uk">${
            successMessages[1]
          }</span>
          <span class="bss-b2b-translation-vat-form_success_message_abn">${
            successMessages[2]
          }</span>
          <span class="bss-b2b-translation-vat-form_success_message_gst">${
            successMessages[3]
          }</span>
          <span class="bss-b2b-translation-vat-form_success_message_us_ein">${
            successMessages[4]
          }</span>
        </span>
      </p>
    </div>
  </div>
  `;
    }
  });
}
